exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-body[data-v-a2aef548]{max-height:550px;overflow-x:auto}.doctorDoctorMenu .doctorMenu[data-v-a2aef548]{margin:15px}", ""]);

// exports
